var _classCallCheck = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\classCallCheck.js");

var _createClass = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\createClass.js");

var _inherits = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\inherits.js");

var _possibleConstructorReturn = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\possibleConstructorReturn.js");

var _getPrototypeOf = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EventEmitter = require('events');

var _require = require('uuid'),
    uuid = _require.v4;

var dev = process.env.NODE_ENV === 'development';
var XHR;

var HTTPConnection = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(HTTPConnection, _EventEmitter);

  var _super = _createSuper(HTTPConnection);

  function HTTPConnection(_XHR, url, options) {
    var _this;

    _classCallCheck(this, HTTPConnection);

    _this = _super.call(this);
    XHR = _XHR;
    _this.options = options;
    _this.connected = false;
    _this.subscriptions = false;
    _this.status = 'loading';
    _this.url = url;
    _this.pollId = uuid();
    setTimeout(function () {
      return _this.create();
    }, 0);

    _this._emit = function () {
      var _this2;

      return !_this.closed ? (_this2 = _this).emit.apply(_this2, arguments) : null;
    };

    return _this;
  }

  _createClass(HTTPConnection, [{
    key: "create",
    value: function create() {
      var _this3 = this;

      if (!XHR) return this._emit('error', new Error('No HTTP transport available'));
      this.on('error', function () {
        if (_this3.connected) _this3.close();
      });
      this.init();
    }
  }, {
    key: "init",
    value: function init() {
      var _this4 = this;

      this.send({
        jsonrpc: '2.0',
        method: 'net_version',
        params: [],
        id: 1
      }, function (err, response) {
        if (err) return _this4._emit('error', err);
        _this4.connected = true;

        _this4._emit('connect');

        _this4.send({
          jsonrpc: '2.0',
          id: 1,
          method: 'eth_pollSubscriptions',
          params: [_this4.pollId, 'immediate']
        }, function (err, response) {
          if (!err) {
            _this4.subscriptions = true;

            _this4.pollSubscriptions();
          }
        });
      });
    }
  }, {
    key: "pollSubscriptions",
    value: function pollSubscriptions() {
      var _this5 = this;

      this.send({
        jsonrpc: '2.0',
        id: 1,
        method: 'eth_pollSubscriptions',
        params: [this.pollId]
      }, function (err, result) {
        if (err) {
          _this5.subscriptionTimeout = setTimeout(function () {
            return _this5.pollSubscriptions();
          }, 10000);
          return _this5._emit('error', err);
        } else {
          if (!_this5.closed) _this5.subscriptionTimeout = _this5.pollSubscriptions();

          if (result) {
            result.map(function (p) {
              var parse;

              try {
                parse = JSON.parse(p);
              } catch (e) {
                parse = false;
              }

              return parse;
            }).filter(function (n) {
              return n;
            }).forEach(function (p) {
              return _this5._emit('payload', p);
            });
          }
        }
      });
    }
  }, {
    key: "close",
    value: function close() {
      if (dev) console.log('Closing HTTP connection');
      clearTimeout(this.subscriptionTimeout);

      this._emit('close');

      this.closed = true;
      this.removeAllListeners();
    }
  }, {
    key: "filterStatus",
    value: function filterStatus(res) {
      if (res.status >= 200 && res.status < 300) return res;
      var error = new Error(res.statusText);
      error.res = res;
      throw error.message;
    }
  }, {
    key: "error",
    value: function error(payload, message) {
      var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

      this._emit('payload', {
        id: payload.id,
        jsonrpc: payload.jsonrpc,
        error: {
          message: message,
          code: code
        }
      });
    }
  }, {
    key: "send",
    value: function send(payload, internal) {
      var _this6 = this;

      if (this.closed) return this.error(payload, 'Not connected');

      if (payload.method === 'eth_subscribe') {
        if (this.subscriptions) {
          payload.pollId = this.pollId;
        } else {
          return this.error(payload, 'Subscriptions are not supported by this HTTP endpoint');
        }
      }

      var xhr = new XHR();
      var responded = false;

      var res = function res(err, result) {
        if (!responded) {
          xhr.abort();
          responded = true;

          if (internal) {
            internal(err, result);
          } else {
            var id = payload.id,
                jsonrpc = payload.jsonrpc;
            var load = err ? {
              id: id,
              jsonrpc: jsonrpc,
              error: {
                message: err.message,
                code: err.code
              }
            } : {
              id: id,
              jsonrpc: jsonrpc,
              result: result
            };

            _this6._emit('payload', load);
          }
        }
      };

      try {
        xhr.open('POST', this.url, true);
        xhr.setRequestHeader('Content-Type', 'application/json'); // Below not working becasue XHR lib blocks it claiming "restricted header"
        // if (this.options.origin) xhr.setRequestHeader('Origin', this.options.origin)

        xhr.timeout = 60 * 1000;
        xhr.onerror = res;
        xhr.ontimeout = res;

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            try {
              var response = JSON.parse(xhr.responseText);
              res(response.error, response.result);
            } catch (e) {
              res(e);
            }
          }
        };

        xhr.send(JSON.stringify(payload));
      } catch (e) {
        if (dev) console.error('Error sending HTTP request', e);
        res({
          message: e.message,
          code: -1
        });
      }
    }
  }]);

  return HTTPConnection;
}(EventEmitter);

module.exports = function (XHR) {
  return function (url, options) {
    return new HTTPConnection(XHR, url, options);
  };
};